import { loggerService } from '@brainpool/logger';

export const handleError = (
  error: unknown,
  context: Record<string, any> | undefined,
  userMessage: string,
  messagePrefix?: string
) => {
  if (error instanceof Error && error.name !== 'AbortError') {
    loggerService.log({
      message: `${messagePrefix || userMessage} ${error.message}`,
      logLevel: 'error',
      error,
      context,
      userMessage: { message: userMessage },
    });
  }
};
